Monitoring.Views ||= {}

class Monitoring.Views.TaggingRulesListView extends Backbone.View
  template: JST["backbone/templates/monitoring/tagging_rules/tagging_rules_list"]

  events:
    'click .edit-tagging-rule': 'onClickEdit'
    'click .delete-tagging-rule': 'onClickDelete'

  initialize: (@options = {}) ->
    @taggingRules    = @options.taggingRules
    @availableTopics = @options.availableTopics
    @availableTags   = @options.availableTags
    @availableSentiments = @options.availableSentiments

  render: =>
    @$el.html(@template(@))
    @

  onClickEdit: (evt) ->
    taggingRuleId = $(evt.currentTarget).data('id')
    tagging_rule_to_edit = @taggingRules.get(taggingRuleId)
    @trigger('edit', tagging_rule_to_edit)

  onClickDelete: (evt) ->
    swal({
        title: I18n.t('monitoring.arrival_alerts.confirmation.are_you_sure')
        type: 'warning'
        showCancelButton: true
        confirmButtonClass: 'btn-danger'
        confirmButtonText: I18n.t('monitoring.arrival_alerts.confirmation.confirm')
        cancelButtonText: I18n.t('monitoring.arrival_alerts.confirmation.cancel')
        closeOnConfirm: true
      }, =>
        taggingRuleId = $(evt.currentTarget).data('id')
        taggingRuleToDelete = @taggingRules.get(taggingRuleId)
        taggingRuleToDelete.destroy(
          success: (response) =>
            console.log("Deleted tagging rule #{taggingRuleToDelete.get('name')}")
            @taggingRules.remove(taggingRuleToDelete)
            @render()
          error: (response) =>
            console.log("Error deleting tagging rule #{taggingRuleToDelete.get('name')}")
        )
    )
